import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsTabPanel from "./en-us/tabpanel.json";
import localizationEnUsTableActive from "./en-us/table-active.json";
import localizationEnUsTableCanceled from "./en-us/table-canceled.json";

export const localizationEnUsSubscriptions = {
  ...localizationEnUsHeader,
  ...localizationEnUsTabPanel,
  ...localizationEnUsTableActive,
  ...localizationEnUsTableCanceled,
};
